module.exports = __webpack_public_path__ + "img/13d-doc-emissao-comentario.1cd6bce9.png";